import React, { Component } from 'react'
import { RadioGroup, Radio } from '../../../libraries/react-radio-group'
import DatePicker from 'react-datepicker'
import format from 'date-fns/format'
import isDate from 'date-fns/isDate'
import isValid from 'date-fns/isValid'
import { DumbField } from '../Field'
import FieldTooltip from '../Tooltip'
import { getValidityClass } from '../Field'
import Portal from 'components/Portal/Portal'
import shortid from 'shortid'
import CalendarIcon from '@tecuity/sos-icons/react/calendar'
import MountDetector from 'components/MountDetector/MountDetector'
import '../../../common/css/react-datepicker.css'
import { noop } from 'utilities'

const DEFAULT_INPUT_MAX_LENGTH = process.env.DEFAULT_INPUT_MAX_LENGTH

export class TextInput extends Component {
  constructor(props){
    super(props);
    this.state = { selectionStart: null }
  }
  static defaultProps = {
    mask: [],
    onBlur: () => {},
  }
  preserveCursor() {
    this.setState({ selectionStart: this.input.selectionStart })
  }
  setCursor() {
    this.input.setSelectionRange(
        this.state.selectionStart,
        this.state.selectionStart,
    )
  }
  componentDidUpdate(prevProps) {
    if(!this.props.mask.length && this.props.value !== prevProps.value && !this.props.disableSelectionRestoration){
      this.setCursor()
    }
    if (this.props.mask.length && this.props.value.length > 0 && this.props.value !== prevProps.value){
      this.setFieldValue({target: {value: this.props.value}})
    }
  }
  hasCharacterLimitMask = () => {
    return this.props.mask.length === 0 ? false : this.props.mask[0].fn === 'maxStringLength'
  }
  setFieldValue = (e) => {
    let value = e.target.value
    if (!this.hasCharacterLimitMask()) {
      value = value.slice(0, DEFAULT_INPUT_MAX_LENGTH || 256)
    }
    this.props.onChange(value, e)
    this.preserveCursor()
  }
  triggerBlur = (e) => {
    if (this.props.onBlur) {
      let value = e.target.value
      if (!this.hasCharacterLimitMask()) {
        value = value.slice(0, DEFAULT_INPUT_MAX_LENGTH || 256)
      }
      this.props.onBlur(value, e)
    }
  }
  onKeyPress = (e) => {
    if (this.props.onKeyPress) {
      this.props.onKeyPress(e)
    }
  }
  focus = () => {
    this.input.focus()
  }
  blur = () => {
    this.input.blur()
  }
  render() {
    let {
      onKeyPress,
      onFocus,
      className = '',
      validityClass = '',
      width,
      name,
      autoComplete,
      disabled,
      index,
      value,
      placeholder,
      maxLength,
      textAlignment = 'left',
      passwordMask,
      onClick,
      required,
      fieldId = '',
      ariaLabel,
      tabIndex,
      isValid,
      style = {}
    } = this.props
    const inputType = passwordMask ? 'password' : 'text'
    return (
      <div className={'text-wrapper ' + className + ' ' + validityClass} style={{ width: width }}>
        <input
          type={inputType}
          onKeyPress={onKeyPress}
          onChange={this.setFieldValue}
          onClick={onClick ? onClick : null}
          onBlur={this.triggerBlur}
          onFocus={onFocus}
          name={name}
          autoComplete={autoComplete}
          disabled={disabled}
          data-index={index}
          value={value ? value : ''}
          placeholder={placeholder}
          aria-required={required}
          aria-label={ariaLabel}
          aria-describedby={`field-description-${fieldId} field-error-${fieldId}`}
          aria-invalid={isValid === false}
          id={fieldId ? `field-${fieldId}` : undefined}
          maxLength={maxLength}
          style={{ textAlign: textAlignment, ...style }}
          tabIndex={tabIndex}
          ref={(input) => {
            this.input = input
          }}
        />
      </div>
    )
  }
}

export class TextArea extends Component {
  static defaultProps = {
    mask: [],
  }
  hasCharacterLimitMask = () => {
    return this.props.mask.length === 0 ? false : this.props.mask[0].fn === 'maxStringLength'
  }
  setFieldValue = (e) => {
    let value = e.target.value
    if (!this.hasCharacterLimitMask()) {
      value = value.slice(0, 1000)
    }
    this.props.onChange(value, e)
  }
  triggerBlur = (e) => {
    if (this.props.onBlur) {
      let value = e.target.value
      if (!this.hasCharacterLimitMask()) {
        value = value.slice(0, 1000)
      }
      this.props.onBlur(value, e)
    }
  }
  focus = () => {
    this.input.focus()
  }
  render() {
    let props = this.props
    return (
      <div
        className={'text-wrapper ' + props.className + ' ' + props.validityClass}
        style={{ width: props.width }}
      >
        <textarea
          id={`field-${props.fieldId}`}
          rows={props.rows}
          onChange={this.setFieldValue}
          onBlur={this.triggerBlur}
          onFocus={this.props.onFocus}
          name={props.name}
          autoComplete={props.autoComplete}
          disabled={props.disabled}
          data-index={props.index}
          value={props.value}
          placeholder={props.placeholder}
          // required={props.required}
          aria-describedby={`field-description-${props.fieldId} field-error-${props.fieldId}`}
          aria-required={props.required}
          aria-invalid={props.isValid === false}
          ref={(input) => {
            this.input = input
          }}
        />
      </div>
    )
  }
}

export class Select extends Component {
  constructor(props) {
    super(props)
    this.id = props.fieldId || shortid.generate()
  }
  componentDidUpdate(prevProps) {
    if(this.props.options.length !== prevProps.options.length) {
      this.setFieldValue({target: {value: this.props.value}})
    }
  }
  setFieldValue = (e) => {
    let selectedIndex = this.props.options.findIndex((option) => option.value === e.target.value)
    this.props.onChange(e.target.value, e, { selectedIndex })
  }
  triggerBlur = (e) => {
    if (this.props.onBlur) {
      if (this.props.bubbleEvents) {
        this.props.onBlur(e)
      } else {
        this.props.onBlur(e.target.value)
      }
    }
  }
  focus = () => {
    this.input.focus()
  }
  getOptionStructure = () => {
    const { options, optionGroups } = this.props
    let groupsObj = {}
    let structure = []

    options.forEach((opt, i) => {
      const isInOptGroup = optionGroups.reduce((bool, optg) => {
        if (i >= optg.start && i <= optg.end) {
          return true
        }
        return bool
      }, false)
      if (isInOptGroup) {
        const group = optionGroups.find((optg) => i >= optg.start && i <= optg.end)
        groupsObj = {
          ...groupsObj,
          [group.id]: {
            ...group,
            ...groupsObj[group.id],
            options: [...((groupsObj[group.id] || {}).options || {}), { ...opt }],
          },
        }
        if (!structure.find((x) => x.type === 'group' && x.id === group.id)) {
          structure.push({ type: 'group', id: group.id })
        }
      } else {
        structure.push({ ...opt, type: 'option' })
      }
    })
    const combinedStrucuture = structure.map((x) => {
      if (x.type === 'option') {
        return x
      } else {
        return { ...x, ...groupsObj[x.id] }
      }
    })
    return combinedStrucuture
  }
  render() {
    let {
      className = '',
      validityClass = '',
      name,
      value = '',
      width,
      options = [],
      optionGroups,
      disabled,
      fieldId,
      required,
      ariaLabel,
      tabIndex,
      isValid
    } = this.props
    return (
      <select
        className={`text-wrapper ${className} ${validityClass}`}
        value={value ? value.toString() : value}
        disabled={disabled}
        aria-required={required}
        aria-label={ariaLabel}
        aria-describedby={`field-description-${fieldId} field-error-${fieldId}`}
        aria-invalid={isValid === false}
        name={name}
        onChange={this.setFieldValue}
        onBlur={this.triggerBlur}
        style={{ width: width }}
        id={`field-${fieldId}`}
        tabIndex={tabIndex}
        ref={(input) => {
          this.input = input
        }}
      >
        {optionGroups
          ? this.getOptionStructure().map((x, i) => {
              if (x.type === 'option') {
                return (
                  <option value={x.value.toString()} disabled={x.disabled}  hidden={x.hidden} key={i}>
                    {x.label}
                  </option>
                )
              } else {
                return (
                  <optgroup label={x.label} key={i}>
                    {x.options.map((opt, k) => (
                      <option value={opt.value.toString()} key={k}>
                        {opt.label}
                      </option>
                    ))}
                  </optgroup>
                )
              }
            })
          : options.map((option, i) => {
              return (
                <option disabled={option.disabled} value={option.value.toString()}  hidden={option.hidden} key={i}>
                  {option.label}
                </option>
              )
            })}
      </select>
    )
  }
}

export class RadioInput extends Component {
  constructor(props) {
    super(props)
    this.id = props.fieldId || shortid.generate()
  }
  focus = () => {
    this.radio.focus()
  }
  setFieldValue = (e) => {
    let selectedIndex = this.props.options.findIndex((option) => option.value === e)
    this.props.onChange(e, { target: { value: e, name: this.props.name } }, { selectedIndex })
  }
  setRef = (radio) => {
    this.radio = radio
  }
  render() {
    let {
      value = '',
      disabled,
      options = [],
      name,
      leftAlign,
      fieldId,
      label,
      required,
      tabIndex,
      isValid
    } = this.props
    return (
      <fieldset aria-required={required}>
        <legend className="visually-hidden">{label}</legend>
        <RadioGroup
          id={`field-${fieldId}`}
          name={name}
          selectedValue={value.toString()}
          className={'radio-group ' + (disabled ? 'disabled' : '')}
          onChange={this.setFieldValue}
          tabIndex={tabIndex}
          aria-describedby={`field-description-${fieldId} field-error-${fieldId}`}
          aria-invalid={isValid === false}
        >
          {options.map((option, i) => {
            return (
              <div className={'option-wrapper ' + (leftAlign ? 'left-align' : '')} key={i}>
                <Radio
                  innerRef={(ref) => {
                    if (i === 0) {
                      this.setRef(ref)
                    }
                  }}
                  name={this.id}
                  id={this.id + i}
                  value={option.value.toString()}
                  disabled={disabled}
                  tabIndex={tabIndex}
                  key={i}
                />
                <label className="field-label radio-label" htmlFor={this.id + i}>
                  {option.label}
                </label>
              </div>
            )
          })}
        </RadioGroup>
      </fieldset>
    )
  }
}

export class Checkbox extends Component {
  setFieldValue = (e) => {
    this.props.onChange(e.target.checked, e)
  }
  focus = () => {
    this.check.focus()
  }
  render() {
    let {
      name,
      value,
      label = '',
      required,
      disabled,
      tooltip,
      fieldId = '',
      tabIndex,
      isValid
    } = this.props
    return (
      <div className="checkbox-wrapper">
        <input
          id={fieldId ? `field-${fieldId}` : undefined}
          name={name}
          type="checkbox"
          disabled={disabled}
          onChange={this.setFieldValue}
          checked={value}
          aria-label={label ? label : undefined}
          aria-required={required}
          aria-describedby={`field-description-${fieldId} field-error-${fieldId}`}
          aria-invalid={isValid === false}
          tabIndex={tabIndex}
          ref={(check) => {
            this.check = check
          }}
          // aria-labelledby={fieldId ? `label-${fieldId}` : undefined}
        />
        <label className="checkbox-box" htmlFor={fieldId ? `field-${fieldId}` : undefined}></label>
        <label
          className="checkbox-label"
          htmlFor={fieldId ? `field-${fieldId}` : undefined}
          id={fieldId ? `label-${fieldId}` : undefined}
        >
          {label}
          {required ? <span className="required">*</span> : null}
          {tooltip !== '' && tooltip ? <FieldTooltip tooltip={tooltip} /> : null}
        </label>
      </div>
    )
  }
}

export class DateInput extends Component {
  state = {
    open: false,
  }
  pickDate = (e, _, skipClose) => {
    if(!skipClose){
      this.closePicker()
    }
    let isDateObject = isDate(e)
    const value = isDateObject ? format(e, 'MM/dd/yyyy') : e
    this.props.onChange(value, { target: { value, name: this.props.name } })
    if (this.props.onButtonClicked) {
      this.props.onButtonClicked(value)
    }
  }
  setFieldValue = (value = '', e) => {
    let v = value.replace(/\D/g, '')
    if (v.length >= 5) {
      v = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`
    } else if (v.length >= 3) {
      v = `${v.slice(0, 2)}/${v.slice(2)}`
    }
    v = v.slice(0, 10)
    this.props.onChange(v, e)
  }
  handleBlur = (value, e) => {
    if (value && value.length >= 10 && isValid(new Date(value))) {
      if (this.props.onBlur) {
        this.props.onBlur(format(new Date(value), 'MM/dd/yyyy'), e)
      }
    } else {
      this.props.onChange(null, e)
      if (this.props.onBlur) {
        this.props.onBlur(null, e)
      }
    }
  }
  openPicker = () => {
    this.textInput.blur()
    this.setState({
      open: true,
    })
    if (this.props.onPickerOpened) this.props.onPickerOpened()
  }
  closePicker = () => {
    this.textInput.focus()
    this.setState({
      open: false,
    })
    if (this.props.onPickerClosed) this.props.onPickerClosed()
  }
  setToday = () => {
    let today
    const stateTimeZone = process.env.STATE_TIMEZONE
    if(stateTimeZone){
      let localDate = new Date()    
      let stateLocalString = localDate.toLocaleString('en-US', {timeZone: stateTimeZone})
      today = format(new Date(stateLocalString), 'MM/dd/yyyy')
    }
    else{
      today = format(new Date(), 'MM/dd/yyyy')
    } 
    this.props.onChange(today, { target: { value: today, name: this.props.name } })
    if (this.props.onButtonClicked) {
      this.props.onButtonClicked(today)
    }
  }
  focusDatePicker = () => {
    const input = document.querySelector('.react-datepicker__input-container input')
    if(input){
      input.focus()
    }
  }
  checkForCalendarEscape = e => {
    if(e.keyCode === 27){
      this.closePicker()
    }
  }
  handleMonthChange = date => {
    this.datePicker.setPreSelection(date)
  }
  handleYearChange = date => {
    this.datePicker.setPreSelection(date)
  }
  focusPreSelection = () => {
    const preSelection = document.querySelector('.react-datepicker__day--keyboard-selected')
    if(preSelection){
      preSelection.focus()
    }
  }
  getSanitizedDates = (value) => {
    let inputValue =
      value && isValid(new Date(value)) ? format(new Date(value), 'MM/dd/yyyy') : value
    let date = value && isValid(new Date(value)) ? new Date(value) : null
    return [date, inputValue]
  }
  render() {
    let {
      value = '',
      className = '',
      validityClass = '',
      disabled,
      isFirst,
      minDate,
      maxDate,
      width,
      fieldId,
      required,
      todayButton,
      tabIndex,
      ariaLabel,
      buttonClassName,
      inputDisabled
    } = this.props
    const stringValue = typeof value === 'string' ? value : ""
    const isFullDate = stringValue.length === 10
    const [date, inputValue] = isFullDate ? this.getSanitizedDates(value) : ["", stringValue]
    const [sanitizedMinDate] = isFullDate ? minDate ? this.getSanitizedDates(minDate) : [undefined] : ""
    const [sanitizedMaxDate] = isFullDate ? maxDate ? this.getSanitizedDates(maxDate) : [undefined] : ""
    return (
      <div className={`date-picker-component`} style={{ position: 'relative' }}>
        <DumbField
          hideLabel
          width={width}
          className={`no-padding date-picker-input ${validityClass}`}
          fieldId={`date-${fieldId}`}
        >
          <TextInput
            fieldId={`date-${fieldId}`}
            className={`date-input ${className}`}
            placeholder="MM/DD/YYYY"
            onChange={this.setFieldValue}
            value={inputValue}
            width="100%"
            onBlur={this.handleBlur}
            ref={(ref) => {
              this.textInput = ref
            }}
            disabled={disabled || inputDisabled}
            required={required}
            tabIndex={tabIndex}
            ariaLabel={ariaLabel}
            disableSelectionRestoration
          />
        </DumbField>
        {todayButton && (
          <button
            type="button"
            disabled={disabled}
            className={`btn btn-primary btn-raised picker-button text-button ${buttonClassName}`}
            onClick={this.setToday}
            tabIndex={tabIndex}
            aria-label={`Enter today's date for: ${ariaLabel}`}
          >
            Today
          </button>
        )}
        <button
          type="button"
          disabled={disabled}
          className={`btn btn-primary btn-raised picker-button ${buttonClassName}`}
          aria-label={`Open calendar widget for: ${ariaLabel}`}
          onClick={this.openPicker}
          tabIndex={tabIndex}
        >
          <CalendarIcon />
        </button>
        <Portal isOpened={this.state.open}>
          <div className="react-datepicker-portal" onKeyDown={this.checkForCalendarEscape}>
            <DatePicker
              inline
              customInput={<input type="text" value={inputValue} />}
              onChange={this.pickDate}
              dateFormat="M/dd/yyyy"
              selected={date}
              calendarClassName="date-pop-in-down"
              disabled={disabled}
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              onMonthChange={this.handleMonthChange}
              onYearChange={this.handleYearChange}
              placeholderText="MM/DD/YYYY"
              autoFocus={isFirst ? true : false}
              minDate={sanitizedMinDate}
              maxDate={sanitizedMaxDate}
              ref={(datePicker) => (this.datePicker = datePicker)}
            >
              <MountDetector onMounted={this.focusPreSelection} />
            </DatePicker>
            <div
              className="shade animated fadeIn extra-fast-animation"
              onClick={this.closePicker}
            />
            <MountDetector onMounted={this.focusDatePicker} />
          </div>
        </Portal>
      </div>
    )
  }
}

export class ConfirmFields extends Component {
  constructor() {
    super()
    this.state = { masked: false }
  }
  focus = () => {
    this.firstInput.focus()
  }
  setFieldVal1 = (value, e) => {
    this.props.onChange({ val1: value, val2: this.props.value.val2 }, e)
  }
  setFieldVal2 = (value, e) => {
    this.props.onChange({ val1: this.props.value.val1, val2: value }, e)
  }
  handleFirstFocus = (e) => {
    this.setState({ masked: false })
  }
  handleFirstBlur = (e) => {
    this.props.onBlur({ ...this.props.value, val1: this.props.value.val1.trim() }, e, null, true, {
      subField: 'first',
    })
  }
  handleSecondFocus = (e) => {
    this.setState({ masked: true })
  }
  handleSecondBlur = (e) => {
    this.setState({ masked: false })
    this.props.onBlur(
      {
        val1: this.props.value.val1.trim(),
        val2: this.props.value.val2.trim(),
      },
      e,
      null,
      true,
      { subField: 'second' }
    )
  }
  getMasked = (value) => {
    let vals = value.split(' ')
    for (let i = 0; i < vals.length; i++) {
      vals[i] = vals[i].replace(/./g, '•')
    }
    return vals.join(' ')
  }
  render() {
    const {
      value,
      name,
      required,
      label,
      description,
      tooltip,
      disabled,
      placeholder,
      width,
      isValid,
      confirmFieldLabel,
      fieldId,
      match = null,
      maskTopField,
    } = this.props
    return (
      <div>
        <DumbField
          type="text"
          required={required}
          label={label}
          description={description}
          tooltip={tooltip}
          errorMessage=""
          hideLabel={false}
          fieldId={`field1-${fieldId}`}
        >
          <TextInput
            fieldId={`field1-${fieldId}`}
            value={
              maskTopField
                ? this.state.masked
                  ? this.getMasked(value.val1)
                  : value.val1
                : value.val1
            }
            onChange={this.setFieldVal1}
            onBlur={this.handleFirstBlur}
            onFocus={this.handleFirstFocus}
            name={name}
            disabled={disabled}
            placeholder={placeholder}
            required={required}
            width={width}
            validityClass={getValidityClass(isValid)}
            ref={(firstInput) => {
              this.firstInput = firstInput
            }}
          />
        </DumbField>
        <DumbField
          type="text"
          required={required}
          label={confirmFieldLabel}
          description=""
          errorMessage=""
          hideLabel={false}
          fieldId={`field2-${fieldId}`}
        >
          <TextInput
            fieldId={`field2-${fieldId}`}
            value={value.val2}
            onChange={this.setFieldVal2}
            onBlur={this.handleSecondBlur}
            onFocus={this.handleSecondFocus}
            name={name}
            disabled={disabled}
            placeholder={placeholder}
            required={required}
            width={width}
            validityClass={getValidityClass(isValid === false ? false : match)}
          />
        </DumbField>
      </div>
    )
  }
}

export class FullName extends Component {
  onChange = (value, e) => {
    this.props.onChange({ ...this.props.value, [e.target.name]: value }, e)
  }
  onBlur = (value, e) => {
    this.props.onBlur(this.props.value, e)
  }
  focus = () => {
    this.fName.focus()
  }
  render() {
    const {
      value,
      required,
      isValid,
      disabled,
      suffix,
      fieldId,
      onlyRequireLastName,
      classNameMap = {}
    } = this.props

    return (
      <div className="row">
        <div className={classNameMap.firstName || "col-sm-5 col-md-4 col-lg-3"}>
          <DumbField
            label="First Name"
            required={required && !onlyRequireLastName}
            description=""
            fieldId={`firstname-${fieldId}`}
          >
            <TextInput
              autoComplete="given-name"
              fieldId={`firstname-${fieldId}`}
              value={value.FIRST_NAME}
              onChange={this.onChange}
              onBlur={noop}
              name={'FIRST_NAME'}
              required={required}
              disabled={disabled}
              width="100%"
              validityClass={
                isValid || !onlyRequireLastName
                  ? getValidityClass(isValid)
                  : onlyRequireLastName
                  ? getValidityClass(null)
                  : getValidityClass(isValid)
              }
              ref={(fName) => {
                this.fName = fName
              }}
            />
          </DumbField>
        </div>
        <div className={classNameMap.middleName || "col-sm-4 col-md-3 col-lg-2"}>
          <DumbField label="Middle/Initial" description="" fieldId={`middle-${fieldId}`}>
            <TextInput
              autoComplete="additional-name"
              fieldId={`middle-${fieldId}`}
              value={value.MIDDLE_NAME}
              onChange={this.onChange}
              onBlur={noop}
              name="MIDDLE_NAME"
              required={required}
              disabled={disabled}
              width="100%"
              validityClass={isValid ? getValidityClass(isValid) : getValidityClass(null)}
            />
          </DumbField>
        </div>
        <div className={classNameMap.lastName || "col-sm-5 col-md-4 col-lg-3"}>
          <DumbField
            label="Last Name"
            required={required}
            description=""
            fieldId={`lastname-${fieldId}`}
          >
            <TextInput
              autoComplete="family-name"
              fieldId={`lastname-${fieldId}`}
              value={value.LAST_NAME}
              onChange={this.onChange}
              onBlur={this.onBlur}
              name={'LAST_NAME'}
              required={required}
              disabled={disabled}
              width="100%"
              validityClass={getValidityClass(isValid)}
            />
          </DumbField>
        </div>
        {suffix && (
          <div className={classNameMap.suffix || "col-sm-4 col-md-3 col-lg-2"}>
            <DumbField label="Suffix" description="" fieldId={`suffix-${fieldId}`}>
              <TextInput
                autoComplete="honorific-suffix"
                fieldId={`suffix-${fieldId}`}
                value={value.SUFFIX}
                onChange={this.onChange}
                onBlur={this.onBlur}
                name={'SUFFIX'}
                disabled={disabled}
                width="100%"
                validityClass={isValid ? getValidityClass(isValid) : getValidityClass(null)}
              />
            </DumbField>
          </div>
        )}
      </div>
    )
  }
}

export const FullNameDisplay = ({ value }) =>
  value.FIRST_NAME +
  (value.MIDDLE_NAME !== '' ? ' ' + value.MIDDLE_NAME + ' ' : ' ') +
  value.LAST_NAME +
  (value.SUFFIX ? ` ${value.SUFFIX}` : '')

export class NameOrg extends Component {
  setFieldValue = (value, e) => {
    var val = { ...this.props.value, [e.target.name]: value }
    this.props.onChange(val, { target: { name: this.props.name, value: val } })
  }
  onBlur = (value, e) => {
    this.props.onBlur(this.props.value, e)
  }
  setNameValue = (value, e) => {
    this.props.onChange(value, e)
  }
  focus = () => {
    this.orgCheck.focus()
  }
  render() {
    const { value, required, disabled, checkboxLabel, fieldId, tooltip } = this.props
    const isOrganization = value.ORG_YN === 'N' || value.ORG_YN === false ? false : true
    return (
      <div className="name-org-control">
        <Checkbox
          fieldId={fieldId}
          value={isOrganization}
          name="ORG_YN"
          disabled={disabled}
          label={!checkboxLabel ? 'This entity is an organization' : checkboxLabel}
          tooltip={tooltip}
          onChange={this.setFieldValue}
          onBlur={this.onBlur}
          ref={(orgCheck) => {
            this.orgCheck = orgCheck
          }}
        />
        {isOrganization ? (
          <DumbField
            label="Organization"
            required={required}
            description=""
            fieldId={`name-org-${fieldId}`}
          >
            <TextInput
              {...this.props}
              autoComplete="organization"
              fieldId={`name-org-${fieldId}`}
              value={value.ORG_NAME}
              name="ORG_NAME"
              onChange={this.setFieldValue}
              onBlur={this.onBlur}
            />
          </DumbField>
        ) : (
          <FullName {...this.props} onChange={this.setNameValue} onBlur={this.onBlur} />
        )}
      </div>
    )
  }
}
export const HOUR_OPTIONS = [
  { value: '', label: '--' },
  ...Array(12)
    .fill(null)
    .map((_, i) => ({ value: i + 1, label: i + 1 })),
]

export const MINUTE_OPTIONS = [
  { value: '', label: '--' },
  ...Array(60)
    .fill(null)
    .map((_, i) => {
      const time = i.toString().length > 1 ? i : `0${i}`
      return { value: time, label: time }
    }),
]

export class TimeInput extends Component {
  getPeriod = (v) => v.split(' ')[1]
  getHour = (v) => (v.search(':') >= 0 ? v.split(':')[0] : '')
  getMinutes = (v) => (v.split(':')[1] || ' ').split(' ')[0]
  onHourChange = (hour) => {
    const { value } = this.props
    const period = this.getPeriod(value)
    const minutes = this.getMinutes(value)
    this.props.onChange(`${hour}:${minutes} ${period}`)
  }
  onMinutesChange = (minutes) => {
    const { value } = this.props
    const period = this.getPeriod(value)
    const hour = this.getHour(value)
    this.props.onChange(`${hour}:${minutes} ${period}`)
  }
  onPeriodChange = (value, splitValue, e) => {
    this.props.onChange(`${splitValue[0]} ${value}`, e)
  }
  onBlur = (splitValue, e) => {
    this.props.onBlur(this.props.value, e, undefined, true)
  }
  render() {
    const { fieldId, value, disabled, isValid } = this.props
    const splitValue = value.split(' ')
    return (
      <div className="flex-row time-input">
        <DumbField fieldId={`time-${fieldId}`}>
          <Select
            ariaLabel="Hour"
            disabled={disabled}
            width="60px"
            fieldId={`time-hours-${fieldId}`}
            value={this.getHour(value)}
            options={HOUR_OPTIONS}
            validityClass={getValidityClass(isValid)}
            onChange={(v, e) => {
              this.onHourChange(v)
            }}
            onBlur={(v, e) => {
              this.onBlur(splitValue, e)
            }}
          />
        </DumbField>
        <div className="colon"> : </div>
        <DumbField fieldId={`time-${fieldId}`}>
          <Select
            ariaLabel="Hour"
            disabled={disabled}
            width="60px"
            fieldId={`time-minutes-${fieldId}`}
            value={this.getMinutes(value)}
            options={MINUTE_OPTIONS}
            validityClass={getValidityClass(isValid)}
            onChange={(v, e) => {
              this.onMinutesChange(v)
            }}
            onBlur={(v, e) => {
              this.onBlur(splitValue, e)
            }}
          />
        </DumbField>
        <DumbField className="period-select" fieldId={`period-${fieldId}`}>
          <Select
            ariaLabel="Time period"
            disabled={disabled}
            fieldId={`period-${fieldId}`}
            value={splitValue[1]}
            validityClass={getValidityClass(isValid)}
            options={[
              { value: 'am', label: 'am' },
              { value: 'pm', label: 'pm' },
            ]}
            onChange={(v, e) => {
              this.onPeriodChange(v, splitValue)
            }}
            onBlur={(v, e) => {
              this.onBlur(splitValue, e)
            }}
          />
        </DumbField>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/Form.js